import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';

import { ImageComponent } from '@valk-nx/components/ui-image/src/lib/image.component';
import { Sizes } from '@valk-nx/components/ui-image/src/lib/image.interface';
import { VideoComponent } from '@valk-nx/components/ui-video/src/lib/video';
import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';
import type { PhotoInterface } from '@valk-nx/core/lib/interfaces/image.interface';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-storytelling',
	templateUrl: './storytelling.html',
	imports: [CommonModule, ImageComponent, VideoComponent],
})
export class StorytellingComponent extends BaseDirective {
	@Input() image: PhotoInterface = { src: '' };
	@Input() video: { vimeoId: number; showControls: boolean };
	@Input() extraImage: PhotoInterface = { src: '' };
	@Input() position: 'left' | 'right' = 'left';
	@Input() isFullscreen = false;

	sizes = Sizes;

	// Below md the slot is square while the image is 1600x1250, so
	// object-cover needs 1600/1250 of the slot width (128vw).
	protected readonly fullscreenSizes = '(min-width: 768px) 100vw, 128vw';
	protected readonly insetSizes =
		'(min-width: 1280px) 992px, (min-width: 1024px) calc(100vw - 288px), (min-width: 768px) 100vw, 128vw';
}
